import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalReservaConfirmadaComponent } from '../modal-reserva-confirmada/modal-reserva-confirmada.component';

@Component({
  selector: 'app-modal-reserva',
  templateUrl: './modal-reserva.component.html',
  styleUrls: ['./modal-reserva.component.css']
})
export class ModalReservaComponent implements OnInit {
  @Input() id_reservacion: string;
  @Input() id_paquete: string;
  id: string;
  data: any;
  cadena: string;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private viajeService: ViajesService, 
    private auxService: AuxiliarService,
    public router: Router, 
  ) { }

  ngOnInit(): void {
    this.obtenerDatos();

  }
  obtenerDatos(){
    this.viajeService.getDataReservacion(this.id_reservacion).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.id = this.id_reservacion
        this.data =  data.body;
        this.cadena = '';
        if(this.data.habitacion.individual !== "0"){
          this.cadena = this.cadena.concat(this.data.habitacion.individual + ' Individual');
        }
        if(this.data.habitacion.doble !== "0") {
          if(this.data.habitacion.individual !== "0")
            this.cadena = this.cadena.concat(' - ');
          this.cadena = this.cadena.concat(this.data.habitacion.doble + ' Doble');
        }
        if(this.data.habitacion.triple !== "0"){ 
          if(this.data.habitacion.individual !== "0" || this.data.habitacion.doble !== "0")
            this.cadena = this.cadena.concat(' - ');
          this.cadena = this.cadena.concat(this.data.habitacion.triple + ' Triple');
        }
        if(this.data.habitacion.cuadruple !== "0") {
          if(this.data.habitacion.individual !== "0" || this.data.habitacion.doble !== "0" || this.data.habitacion.triple !== "0")
            this.cadena = this.cadena.concat(' - ');
            this.cadena = this.cadena.concat(this.data.habitacion.cuadruple + ' Cuadruple');
        }        
      }
    });
  }
  openModalReservaConfirmada() {    
    const modalRef = this.modalService.open(ModalReservaConfirmadaComponent, { 
      centered: true,  
      backdrop:'static' 
    });  
    modalRef.componentInstance.id = this.id;    
    this.closeModal();
  }
   
  goReservation(){
    this.activeModal.dismiss('Cross click');
    this.router.navigate(['/','tours', 'reservation' ,this.id_paquete]);
  }
  goPassengers(){
    this.activeModal.dismiss('Cross click');
    this.router.navigate(['/','tours', 'tour-passangers' ,this.id_paquete]);
  }

  closeModal(){
    //this.router.navigate(['/tours/']);
    this.activeModal.dismiss('Cross click');
  }

}
